import React from 'react'
import './input.scss'

type TInput = {
	className?: string;
	value: string | number;
	name: string;
	placeholder?: string;
	type: string;
	required?: boolean;
	key?: string;
	handleChange: any;
}

const Input = (props: TInput) => {

	const { handleChange, className = "", value, name, placeholder = "Escribe tu respuesta", type, required = false, key } = props;

	return (
		<input
			className={`a-input ${className}`}
			value={value}
			onChange={handleChange}
			name={name}
			placeholder={placeholder}
			type={type}
			required={required}
			key={key}
		/>
	)
}

export default Input